<template>
  <div
    id="page-container"
    class="enable-page-overlay side-scroll main-content-boxed"
  >
    <header-component></header-component>
    <sidebar-component></sidebar-component>
    <div class="alert alert-danger mb-0" role="alert" v-show="error">
      <div class="container" v-html="error" id="editErrorMessage">
        <!-- {{ error }} -->
      </div>
    </div>
    <main id="main-container">
      <div class="content">
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label class="col-form-label">Form Title</label>
              <input
                class="form-control"
                name="FormName"
                id="FormName"
                v-model="form.data.name"
                placeholder="Form Title"
                required
              />
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="col-form-label">Form Type</label>
              <select
                id="FormType"
                class="form-control custom-select small-arrow"
                name="FormType"
                v-model="form.data.type"
                required
              >
                <option value="0">Public</option>
                <option value="1">Client</option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="col-form-label">Action Type</label>
              <select
                id="ActionType"
                class="form-control custom-select small-arrow"
                name="ActionType"
                v-model="form.data.action"
                @change="updateAction"
                required
              >
                <option value="0">Lead</option>
                <option value="1">Contract</option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="col-form-label">Customer Widget</label>
              <select
                id="CustomerWidget"
                class="form-control custom-select small-arrow"
                name="CustomerWidget"
                v-model="form.data.customerwidget"
                required
                @change="addCustomerWidget()"
              >
                <option value="0">Disabled</option>
                <option value="1">Enabled</option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="col-form-label">Customer Type</label>
              <select
                id="CustomerType"
                class="form-control custom-select small-arrow"
                name="CustomerType"
                v-model="form.data.customertype"
                required
              >
                <option value="1">Consumer</option>
                <option value="2">Business</option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="col-form-label">Language</label>
              <select
                id="LanguageType"
                class="form-control custom-select small-arrow"
                name="LanguageType"
                v-model="form.data.language"
                required
              >
                <option value="multi">Multiple</option>
                <option value="en">English</option>
                <option value="nl">Dutch</option>
              </select>
            </div>
          </div>
          <div id="clients-div" class="row col-md-12">
            <div
              v-for="client in clientNumber"
              :key="client"
              class="row col-md-12"
            >
              <div class="col-md-6" v-if="form.data.type == 1">
                <div class="form-group">
                  <label class="col-form-label">Clients</label>
                  <multiselect
                    :id="'multiselect-' + client"
                    v-model="selectedClients[client - 1]"
                    label="name"
                    track-by="id"
                    :options="clients"
                    :multiple="false"
                    :options-limit="50000"
                  >
                    <!-- <template v-slot:afterList>
                  <div>
                    <button
                      v-if="page < lastPage"
                      type="button"
                      class="btn btn-light btn-block"
                      @click="loadMore()"
                    >{{ translate[lang]["loadmore"] }}</button>
                  </div>
                </template> -->
                  </multiselect>
                </div>
              </div>
              <div class="col-md-4" v-if="form.data.type == 1">
                <!--Success URL-->
                <div class="form-group">
                  <label class="col-form-label">Success URL</label>
                  <input
                    class="form-control"
                    :name="'successURL-' + client"
                    :id="'successURL-' + client"
                    placeholder="Client URL"
                    required
                  />
                </div>
              </div>
              <div
                class="col-md-2"
                v-if="form.data.type == 1"
                style="margin-top: 35px"
              >
                <button class="btn btn-success" type="button" @click="addUrl">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
              <!--clone button-->
            </div>
          </div>

          <!--Success URL-->
          <!--client & client url clone button-->

          <draggable
            v-model="form.data.fields"
            group="section"
            class="col-md-12"
          >
            <Section
              v-for="(item, keyItem) in this.form.data.fields"
              v-if="!Array.isArray(item)"
              :key="keyItem"
              :index="keyItem"
              :data="item"
            ></Section>
            <div
              class="block"
              v-else-if="item.length > 0"
              v-show="form.data.action == 1"
            >
              <div class="block-header block-header-default">
                <h3 class="block-title">
                  {{ item.filter(x => x.type !== "html")[0].title[lang] }}
                </h3>
                <div class="block-options">
                  <button
                    type="button"
                    class="btn-block-option"
                    data-toggle="block-option"
                    data-action="content_toggle"
                  >
                    <i class="si si-arrow-up"></i>
                  </button>
                  <button
                    type="button"
                    class="btn-block-option"
                    @click="addComment(item)"
                  >
                    <i class="si si-note"></i>
                  </button>
                </div>
              </div>
              <div class="block-content">
                <draggable v-model="form.data.fields[keyItem]">
                  <Section
                    v-for="item2 in item"
                    :key="item2.id"
                    :index="keyItem"
                    :data="item2"
                  ></Section>
                </draggable>
              </div>
            </div>
          </draggable>
        </div>
        <div class="row">
          <div class="col-3">
            <button
              class="btn btn-outline-warning btn-lg btn-block"
              @click="$router.push('/')"
            >
              Dashboard
            </button>
          </div>
          <div class="col-3">
            <button
              class="btn btn-outline-info btn-lg btn-block"
              @click="preview(1)"
            >
              Save as Draft
            </button>
          </div>
          <div class="col-3">
            <button
              class="btn btn-outline-success btn-lg btn-block"
              @click="preview(2)"
            >
              Publish
            </button>
          </div>
          <div class="col-3">
            <button
              class="btn btn-outline-danger btn-lg btn-block"
              type="button"
              data-toggle="modal"
              data-target="#modal-block-custom-css"
              @click="handleCssModalInputs"
            >
              Add Custom Css
            </button>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </main>
    <div
      class="modal"
      id="modal-block-form-json"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-block-form-json"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Form Json</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <pre class="json">
            <code>{{ this.form.data.fields }}</code>
          </pre>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-sm btn-light"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-sm btn-primary"
              data-dismiss="modal"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
    <form-add-modal></form-add-modal>
    <section-add-modal></section-add-modal>
    <supplier-add-modal></supplier-add-modal>
    <custom-css-modal></custom-css-modal>
  </div>
</template>
<script>
import Section from "../components/shared/Section";
import draggable from "vuedraggable";
import SectionAddModal from "../components/modals/SectionAddModal";
import SupplierAddModal from "../components/modals/SupplierAddModal";
import FormAddModal from "../components/modals/FormAddModal";
import HeaderComponent from "../components/layout/Header";
import SidebarComponent from "../components/layout/Sidebar";
import formService from "../services/api/FormApi";
import CustomCssModal from "../components/modals/CustomCssModal";
import { mapActions, mapState } from "vuex";
import $ from "jquery";
export default {
  name: "Editor",
  data: function() {
    return {
      error: null,
      warning: null,
      addressComponent: "",
      dateComponent: "",
      cityheatComponent: "",
      waterComponent: "",
      page: 1,
      lastPage: 0,
      clientsForLoad: [],
      familySituationComponent: "",
      insuranceForLead: "",
      mortgageWidget: "",
      commentCount: 0,
      clientNumber: 1,
      selectedClients: [],
      clientsWithUrls: []
    };
  },
  components: {
    SidebarComponent,
    HeaderComponent,
    FormAddModal,
    SupplierAddModal,
    SectionAddModal,
    draggable,
    Section,
    CustomCssModal
  },
  beforeCreate() {
    this.$store.commit("forms/CLEAR_FORM");
  },
  async created() {
    await this.getTranslate();
    this.getFormById({
      id: this.$route.params.id,
      type: "auth",
      isShow: false,
      isSubmitted: false
    }).then(() => {
      this.setCustomCss();
      if (this.form.data.clients) {
        if (this.form.data.clients.length > 0) {
        this.clientNumber = this.form.data.clients.length;
        } else {
          this.clientNumber = 1;
        }
      }
    });
    await this.getAllAllWidgets(true).then(() => {});
    this.getClients(2000).then(() => {
      if (this.form.data.clients) {
        this.selectedClients = this.form.data.clients;
        this.form.data.clients.map((client, index) => {
          if (client.successUrl) {
            $(`#successURL-${index + 1}`).val(client.successUrl);
          }
        });
      }
    });
  },
  computed: {
    ...mapState({
      widgets: state => state.widgets.AllAllWidgets,
      draftID: state => state.forms.draftID,
      clients: state => state.forms.clients,
      formFields: state => state.forms.formStateData.data.fields,
      trigger: state => state.forms.trigger
    }),
    cIsNeedFamilySituation() {
      return (
        this.products.filter(
          x =>
            x.group === "electricity" ||
            x.group === "gas" ||
            x.group === "water" ||
            x.group === "stadswarmte"
        ).length > 0
      );
    },
    cHasFamilySituation() {
      return (
        this.form.data.fields.filter(
          x => !Array.isArray(x) && x.type === "familySituation"
        ).length > 0
      );
    }
  },
  methods: {
    ...mapActions({
      getFormById: "forms/getFormById",
      getAllAllWidgets: "widgets/getAllAllWidgets",
      postFormById: "forms/postFormById",
      getAllForm: "forms/getAllForm",
      saveAndDraft: "forms/saveAndDraft",
      getClients: "forms/getClients",
      getTranslate: "translate/getTranslate"
    }),
    handleClientsUrls() {
      this.selectedClients.map((client, index) => {
        this.clientsWithUrls.push({
          ...client,
          successUrl: $(`#successURL-${index + 1}`).val()
        });
      });
      this.$store.state.forms.formStateData.data.clients = this.clientsWithUrls;
      debugger;
    },
    addUrl() {
      this.clientNumber++;
    },
    setCustomCss() {
      if (this.form.data.attributes) {
        Object.keys(this.form.data.attributes).map(a => {
          if (this.form.data.attributes[a].isTag) {
            let cssAttributes = this.form.data.attributes[a].attributes.split(
              "\n"
            );
            cssAttributes.map(x => {
              let attribute = x.split(":")[0];
              let value = x.split(":")[1];
              $(a).css(`${attribute}`, value);
            });
          } else {
            let className = a.replace("_", "-");
            let cssAttributes = this.form.data.attributes[a].attributes.split(
              "\n"
            );
            cssAttributes.map(x => {
              let attribute = x.split(":")[0];
              let value = x.split(":")[1];
              $(`.${className}`).css(`${attribute}`, value);
            });
          }
        });
      }
    },
    handleCssModalInputs() {
      if (this.form.data.attributes) {
        Object.keys(this.form.data.attributes).map(a => {
          // console.log(this.form.data.attributes[a].attributes)
          if (this.form.data.attributes[a].isTag) {
            if (document.getElementById(a + "-css")) {
              document.getElementById(
                a + "-css"
              ).value = this.form.data.attributes[a].attributes;
            }
          } else {
            let tempId = a.replace("_", "-");
            let id = tempId + "-css";
            if (document.getElementById(id)) {
              document.getElementById(id).value = this.form.data.attributes[
                a
              ].attributes;
            }
          }
        });
      }
    },
    addComment: function(item) {
      let id = 1;
      let section = item.filter(x => x.type === "suppliers")[0].group;
      if (item.filter(x => x.type === "commentWidget").length > 0) {
        id = item.filter(x => x.type === "commentWidget").length + 1;
      }
      let commentComponent = {
        id: item.filter(x => x.type === "suppliers")[0].group + "-" + id,
        group: "widget",
        fromGroup: item.filter(x => x.type === "suppliers")[0].group,
        type: "commentWidget",
        title: {
          en: "Comment",
          nl: "Comment"
        },
        description: {},
        css: "",
        html: "",
        comment: "",
        subtitle: {
          en: "writeacomment",
          nl: "writeacomment"
        }
      };
      if (
        section === "electricity" ||
        section === "gas" ||
        section === "electricityandgas"
      ) {
        // this.$store.state.forms.formStateData.data.fields[index]
        this.$store.state.forms.formStateData.data.fields.map((item, index) => {
          if (Array.isArray(item)) {
            item.map(a => {
              if (a.type === "suppliers" && a.group === section) {
                this.$store.state.forms.formStateData.data.fields[index] = [
                  ...this.$store.state.forms.formStateData.data.fields[index],
                  commentComponent
                ];
              }
            });
          }
        });
        this.$forceUpdate();
      } else {
        item.push(commentComponent);
      }
      //for some reason vue cant decide to re render the view so with forceUpdate
      //we can re render the view and comments will not fail
    },
    firstLoad: function() {
      this.getClients(2000).then(res => {
        this.clientsForLoad = res.data.data;
      });
    },
    loadMore: function() {
      if (this.page < this.lastPage) {
        this.page++;
        this.getClients(this.page).then(res => {
          this.clientsForLoad = [...this.clientsForLoad, ...res.data.data];
        });
      }
    },
    preview: function(status) {
      this.error = null;
      if (this.form.data.name == undefined) {
        this.error = this.error ? this.error : "";
        this.error += "<p class='mb-0'>- " + "Form title is required!" + "</p>";
      }
      if (this.form.data.name.length <= 2) {
        this.error = this.error ? this.error : "";
        this.error +=
          "<p class='mb-0'>- " +
          "Form title must be at least 3 character!" +
          "</p>";
      }
      if (this.form.data.type == undefined) {
        this.error = this.error ? this.error : "";
        this.error += "<p class='mb-0'>- " + "Form type is required!" + "</p>";
      }
      if (this.form.data.action == undefined) {
        this.error = this.error ? this.error : "";
        this.error +=
          "<p class='mb-0'>- " + "Action type is required!" + "</p>";
      }
      if (this.form.data.customerwidget == undefined) {
        this.error = this.error ? this.error : "";
        this.error +=
          "<p class='mb-0'>- " + "Customer widget is required!" + "</p>";
      }
      if (this.form.data.customertype == undefined) {
        this.error = this.error ? this.error : "";
        this.error +=
          "<p class='mb-0'>- " + "Customer type is required!" + "</p>";
      }
      if (this.form.data.language == undefined) {
        this.error = this.error ? this.error : "";
        this.error += "<p class='mb-0'>- " + "Language is required!" + "</p>";
      }
      //For seperated electricity and gas
      let sections = this.formFields.filter(
        x => !Array.isArray(x) && x.group === "sections"
      );
      //if electricity an gas both selected
      let isElectricityAndGas =
        this.products.filter(
          x => x.group === "electricity" || x.group === "gas"
        ).length > 1;
      let count = 0;
      if (sections.length > 1) {
        // if connection sections are more then 1
        if (isElectricityAndGas) {
          // if electricity and gas connections are both selected
          sections.map(x => {
            //if section has only electricity or only gas connection
            if (
              x.products.filter(
                a => a.group === "electricity" || a.group === "gas"
              ).length <= 1
            ) {
              count++;
            }
          });
          if (count == sections.length) {
            this.error +=
              "<p class='mb-0'>- " +
              "Electricity and Gas connections can't be seperated!" +
              "</p>";
          }
        }
      }
      this.formFields.forEach(x => {
        if (Array.isArray(x) && x.length > 0) {
          let tempProductArray = x.filter(y => y.type === "suppliers")[0];
          if (
            tempProductArray.group === "internet" &&
            this.form.data.action == 1
          ) {
            let tempDefaults = {};
            let ziggo = tempProductArray.suppliers.filter(
              x => x.title === "Vodafone Ziggo"
            );
            let tMobile = tempProductArray.suppliers.filter(
              x => x.title === "T-Mobile"
            );
            let kpn = tempProductArray.suppliers.filter(x => x.title === "KPN");
            let youfone = tempProductArray.suppliers.filter(
              x => x.title === "Youfone"
            );
            if (ziggo.length > 0) {
              tempDefaults.ziggo = {
                internet: null,
                tv: null,
                call: null
              };
            }
            if (tMobile.length > 0) {
              tempDefaults.tMobile = {
                internet: null,
                tv: null,
                mobile: null
              };
            }
            if (kpn.length > 0) {
              tempDefaults.kpn = {
                internet: null,
                tv: null,
                call: null
              };
            }
            if (youfone.length > 0) {
              tempDefaults.youfone = {
                internet: null,
                tv: null
              };
            }
            tempProductArray.suppliers.map(x => {
              if (x.default !== null) {
                if (x.title === "Vodafone Ziggo") {
                  tempDefaults.ziggo[x.category_field] = 1;
                } else if (x.title === "T-Mobile") {
                  tempDefaults.tMobile[x.category_field] = 1;
                } else if (x.title === "KPN") {
                  tempDefaults.kpn[x.category_field] = 1;
                } else if (x.title === "Youfone") {
                  tempDefaults.youfone[x.category_field] = 1;
                }
              }
            });
            Object.keys(tempDefaults).map(a => {
              Object.keys(tempDefaults[a]).map(x => {
                if (a === "ziggo" && tempDefaults[a][x] === null) {
                  this.error = this.error ? this.error : "";
                  this.error +=
                    "<p class='mb-0'>- " +
                    ("Default supplier for " +
                      "Vodafone Ziggo " +
                      x +
                      " is required!") +
                    "</p>";
                } else if (a === "tMobile" && tempDefaults[a][x] === null) {
                  this.error = this.error ? this.error : "";
                  this.error +=
                    "<p class='mb-0'>- " +
                    ("Default supplier for " +
                      "T-Mobile " +
                      x +
                      " is required!") +
                    "</p>";
                } else if (a === "kpn" && tempDefaults[a][x] === null) {
                  this.error = this.error ? this.error : "";
                  this.error +=
                    "<p class='mb-0'>- " +
                    ("Default supplier for " + "KPN " + x + " is required!") +
                    "</p>";
                } else if (a === "youfone" && tempDefaults[a][x] === null) {
                  this.error = this.error ? this.error : "";
                  this.error +=
                    "<p class='mb-0'>- " +
                    ("Default supplier for " +
                      "Youfone " +
                      x +
                      " is required!") +
                    "</p>";
                }
              });
            });
          }
          if (
            tempProductArray.group === "mobile" &&
            this.form.data.action == 1
          ) {
            let tempDefaults = {};
            let vodafone = tempProductArray.suppliers.filter(
              x => x.title === "Vodafone"
            );
            let tMobile = tempProductArray.suppliers.filter(
              x => x.title === "T-Mobile"
            );
            let kpn = tempProductArray.suppliers.filter(x => x.title === "KPN");
            let youfone = tempProductArray.suppliers.filter(
              x => x.title === "Youfone"
            );
            if (vodafone.length > 0) {
              tempDefaults.vodafone = {
                package: null
              };
            }
            if (tMobile.length > 0) {
              tempDefaults.tMobile = {
                package: null
              };
            }
            if (kpn.length > 0) {
              tempDefaults.kpn = {
                internet: null,
                call: null
              };
            }
            if (youfone.length > 0) {
              tempDefaults.youfone = {
                internet: null,
                call: null
              };
            }
            tempProductArray.suppliers.map(x => {
              if (x.default !== null) {
                if (x.title === "Vodafone") {
                  tempDefaults.vodafone[x.category_field] = 1;
                } else if (x.title === "T-Mobile") {
                  tempDefaults.tMobile[x.category_field] = 1;
                } else if (x.title === "KPN") {
                  tempDefaults.kpn[x.category_field] = 1;
                } else if (x.title === "Youfone") {
                  tempDefaults.youfone[x.category_field] = 1;
                }
              }
            });
            Object.keys(tempDefaults).map(a => {
              Object.keys(tempDefaults[a]).map(x => {
                if (a === "vodafone" && tempDefaults[a][x] === null) {
                  this.error = this.error ? this.error : "";
                  this.error +=
                    "<p class='mb-0'>- " +
                    ("Default supplier for SIM Only " +
                      "Vodafone " +
                      x +
                      " is required!") +
                    "</p>";
                } else if (a === "tMobile" && tempDefaults[a][x] === null) {
                  this.error = this.error ? this.error : "";
                  this.error +=
                    "<p class='mb-0'>- " +
                    ("Default supplier for SIM Only " +
                      "T-Mobile " +
                      x +
                      " is required!") +
                    "</p>";
                } else if (a === "kpn" && tempDefaults[a][x] === null) {
                  this.error = this.error ? this.error : "";
                  this.error +=
                    "<p class='mb-0'>- " +
                    ("Default supplier for SIM Only " +
                      "KPN " +
                      x +
                      " is required!") +
                    "</p>";
                } else if (a === "youfone" && tempDefaults[a][x] === null) {
                  this.error = this.error ? this.error : "";
                  this.error +=
                    "<p class='mb-0'>- " +
                    ("Default supplier for SIM Only " +
                      "Youfone " +
                      x +
                      " is required!") +
                    "</p>";
                }
              });
            });
          }
          if (
            tempProductArray &&
            tempProductArray.suppliers.length <= 0 &&
            this.form.data.action == 1
          ) {
            this.error = this.error ? this.error : "";
            this.error +=
              "<p class='mb-0'>- " +
              ("Supplier for " +
                tempProductArray.group +
                " product is required!") +
              "</p>";
          }
          if (
            this.form.data.action == 1 &&
            tempProductArray &&
            tempProductArray.product !== 8 &&
            tempProductArray.product !== 4 &&
            tempProductArray.product != 10 &&
            tempProductArray.product != 9 &&
            !tempProductArray.default
          ) {
            this.error = this.error ? this.error : "";
            this.error +=
              "<p class='mb-0'>- " +
              ("Default supplier for " +
                tempProductArray.group +
                " product is required!") +
              "</p>";
          }
          if (
            this.form.data.action == 1 &&
            tempProductArray &&
            (tempProductArray.product === 8 ||
              tempProductArray.product === 4 ||
              tempProductArray.product === 9) &&
            !tempProductArray.suppliers.some(a => a.default !== null)
          ) {
            this.error = this.error ? this.error : "";
            this.error +=
              "<p class='mb-0'>- " +
              ("Default supplier for " +
                tempProductArray.group +
                " product is required!") +
              "</p>";
          }
          if (
            this.form.data.action == 1 &&
            tempProductArray &&
            (tempProductArray.product === 8 ||
              tempProductArray.product === 4 ||
              tempProductArray.product === 9) &&
            tempProductArray.groupDefault === null
          ) {
            this.error = this.error ? this.error : "";
            this.error +=
              "<p class='mb-0'>- " +
              ("Default provider for " +
                tempProductArray.group +
                " product is required!") +
              "</p>";
          }
        }
      });
      if (this.error) {
        window.location.hash = "#editErrorMessage";
      }
      if (!this.error) {
        this.$store.state.sections.previewForm = [
          ...this.$store.state.forms.formStateData.data.fields
        ];
        /*If Order Change Suppliers, set list*/
        this.form.data.fields.forEach(x => {
          if (Array.isArray(x)) {
            let checkOrdered = x.filter(
              item => item.type === "suppliers" && item.suppliersReOrder
            );
            if (checkOrdered.length > 0) {
              checkOrdered[0].suppliers = checkOrdered[0].suppliersReOrder;
              delete checkOrdered[0].suppliersReOrder;
            }
          }
        });
        this.handleClientsUrls();
        var formData = {
          FormName: this.form.data.name,
          language: this.form.data.language,
          FormType: parseInt(this.form.data.type),
          ActionType: parseInt(this.form.data.action),
          CustomerWidget: this.form.data.customerwidget,
          CustomerType: this.form.data.customertype,
          Clients: JSON.stringify(this.clientsWithUrls),
          Success_Url: JSON.stringify(this.clientsWithUrls),
          FormContent: this.form.data.fields,
          Attributes: JSON.stringify(this.form.data.attributes),
          status
        };
        if (this.checkSuppliersFilterStatus() && !this.isLead) {
          this.$swal
            .fire({
              icon: "warning",
              title: "",
              html:
                this.warning +
                " The suppliers that you have chosen are not included in all consumption filters. This may occur problems on the form. Do you want to proceed?",
              showDenyButton: true,
              showCancelButton: true,
              confirmButtonText: "Proceed",
              denyButtonText: "Cancel"
            })
            .then(result => {
              if (result.isConfirmed) {
                if (this.$route.params.id > 0) {
                  var a = { formData: formData, id: this.$route.params.id };
                  formService.postFormById(a).then(() =>
                    this.$router.push({
                      name: "Preview",
                      params: { id: this.$route.params.id }
                    })
                  );
                } else {
                  this.saveAndDraft(formData).then(() => {
                    this.$router.push({
                      name: "Preview",
                      params: { id: this.draftID }
                    });
                  });
                }
              }
            });
        } else {
          if (this.$route.params.id > 0) {
            var a = { formData: formData, id: this.$route.params.id };
            formService.postFormById(a).then(() =>
              this.$router.push({
                name: "Preview",
                params: { id: this.$route.params.id }
              })
            );
          } else {
            this.saveAndDraft(formData).then(() => {
              this.$router.push({
                name: "Preview",
                params: { id: this.draftID }
              });
            });
          }
        }
      }
    },
    checkSuppliersFilterStatus() {
      this.warning = "";
      let count = 0;
      this.formFields
        .filter(x => Array.isArray(x))
        .map(y => {
          y.map(z => {
            if (z.type === "suppliers") {
              let suppliersWithOutFilter = z.suppliers.filter(
                x =>
                  x.filters &&
                  x.filters.kwh &&
                  x.filters.kwh.max === null &&
                  x.filters.kwh.min === null &&
                  x.filters.m3 &&
                  x.filters.m3.max === null &&
                  x.filters.m3.min === null
              );
              if (suppliersWithOutFilter.length < 1) {
                this.warning += "<p class='mb-0'>- " + z.group + " " + "</p>";
                count++;
              }
            }
          });
        });

      if (count > 0) {
        return true;
      } else {
        return false;
      }
    },

    addCustomerWidget: function() {
      if (this.form.data.customerwidget === "1") {
        this.form.data.fields.push({
          id: 9999,
          action: "",
          group: "customerwidget",
          type: "html",
          title: "Customer Widget",
          description: {},
          css: "custom css",
          widgetCardId: 0,
          html: ""
        });
      } else {
        let key = this.form.data.fields.findIndex(
          x => x.group === "customerwidget"
        );
        if (key > 0) {
          this.form.data.fields.splice(key, 1);
        }
      }
    },
    updateAction: function() {
      if (this.form.data.action == 1) {
        this.$store.state.forms.formStateData.data.fields.push(
          this.dateComponent,
            this.waterComponent,
            this.cityheatComponent
        );
      } else {
        for (
          let i = 0;
          i < this.$store.state.forms.formStateData.data.fields.length;
          i++
        ) {
          if (
            this.$store.state.forms.formStateData.data.fields[i].type ===
            "datewidget"
          ) {
            this.$store.state.forms.formStateData.data.fields.splice(i, 1);
          }
        }
      }
      if (
        this.form.data.action == 1 &&
        this.products.filter(x => x.code === "mortgage").length > 0 &&
        this.form.data.fields.filter(x => x.widgetCardId === 21).length < 1
      ) {
        this.$store.state.forms.formStateData.data.fields.push(
          this.mortgageWidget
        );
      }
    },
    addOrRemoveFamilySituation() {
      let newId =
        this.$store.state.forms.formStateData.data.fields[
          this.$store.state.forms.formStateData.data.fields.length - 1
        ].id + 1;
      this.familySituationComponent = {
        id: newId + 2,
        action: "familysituation",
        group: "widget",
        type: "familySituation",
        title: "Family Situation",
        description: {},
        css: "",
        widgetCardId: 19,
        html: ""
      };
      if (this.cHasFamilySituation && !this.cIsNeedFamilySituation) {
        //delete
        for (
          let i = 0;
          i < this.$store.state.forms.formStateData.data.fields.length;
          i++
        ) {
          if (
            this.$store.state.forms.formStateData.data.fields[i].type ===
            "familySituation"
          ) {
            this.$store.state.forms.formStateData.data.fields.splice(i, 1);
          }
        }
      } else if (!this.cHasFamilySituation && this.cIsNeedFamilySituation) {
        //add
        this.$store.state.forms.formStateData.data.fields.push(
          this.familySituationComponent
        );
      }
    },
    addInsuranceForLead() {
      if (
        this.products.filter(x => x.group === "insurance").length > 0 &&
        this.form.data.fields.filter(
          x => !Array.isArray(x) && x.type === "insuranceForLead"
        ).length <= 0
      ) {
        this.$store.state.forms.formStateData.data.fields.push(
          this.insuranceForLead
        );
      }
    },
    removeInsuranceForLead() {
      if (
        !this.isLead ||
        (this.products.filter(x => x.group === "insurance").length <= 0 &&
          this.form.data.fields.filter(
            x => !Array.isArray(x) && x.type === "insuranceForLead"
          ).length > 0)
      ) {
        for (
          let i = 0;
          i < this.$store.state.forms.formStateData.data.fields.length;
          i++
        ) {
          if (
            this.$store.state.forms.formStateData.data.fields[i].type ===
            "insuranceForLead"
          ) {
            this.$store.state.forms.formStateData.data.fields.splice(i, 1);
          }
        }
      }
    }
  },
  watch: {
    trigger() {
      this.$forceUpdate();
    },
    error() {
      if (this.error) {
        $("html, body").animate({ scrollTop: 0 }, "fast");
        return false;
      }
    },
    widgets() {
      let newId =
        this.$store.state.forms.formStateData.data.fields[
          this.$store.state.forms.formStateData.data.fields.length - 1
        ].id + 1;
      this.addressComponent = {
        id: newId,
        action: "postcode",
        group: "widget",
        type: "html",
        title: this.widgets.data.filter(e => e.id === 3)[0].name,
        description: {},
        css: "",
        widgetCardId: 3,
        html: this.widgets.data.filter(e => e.id === 3)[0].contents
      };
      this.mortgageWidget = {
        id: newId + 3,
        action: "",
        group: "widget",
        type: "html",
        title: this.widgets.data.filter(e => e.id === 21)[0].name,
        description: {},
        css: "custom css",
        widgetCardId: 21,
        html: this.widgets.data.filter(e => e.id === 21)[0].contents
      };
      this.dateComponent = {
        id: newId + 1,
        group: "widget",
        type: "datewidget",
        title: "Gewenste Ingangsdatum",
        description: {},
        css: "",
        html: ""
      };
      this.cityheatComponent = {
        id: newId + 4,
        group: "widget",
        type: "cityheat",
        title: "Stadswarmte",
        description: {},
        css: "",
        html: ""
      };
      this.waterComponent = {
        id: newId + 5,
        group: "widget",
        type: "water",
        title: "Water",
        description: {},
        css: "",
        html: ""
      };
      this.insuranceForLead = {
        id: newId + 2,
        action: "insuranceForLead",
        group: "widget",
        type: "insuranceForLead",
        title: "Which insurances are you interested in?",
        description: {},
        css: "",
        widgetCardId: 22,
        html: ""
      };

      // this.familySituationComponent = {
      //   id: newId + 2,
      //   action: "familysituation",
      //   group: "widget",
      //   type: "familySituation",
      //   title: "Family Situation",
      //   description: {},
      //   css: "",
      //   widgetCardId: 19,
      //   html: "",
      // };
      if (this.$route.params.id <= 0) {
        this.$store.state.forms.formStateData.data.fields.push(
          this.addressComponent
        );
      }
    },
    products: {
      handler: function(newArr, oldArr) {
        if (!this.isLead && newArr.length != oldArr.length) {
          this.addOrRemoveFamilySituation();
        }
        if (this.isLead && newArr.length != oldArr.length) {
          this.addInsuranceForLead();
          this.removeInsuranceForLead();
        }
      },
      deep: false
    },
    isLead(value) {
      if (!value) {
        this.addOrRemoveFamilySituation();
        this.removeInsuranceForLead();
      } else {
        this.addInsuranceForLead();
      }
    }
  }
};
</script>
